import { Injectable } from "@angular/core";
import { OrderService } from "@core/models/order-service";
import { OrderServiceUpdate } from "@core/models/order-service-update";


@Injectable({
	providedIn: 'root'
})
/** Contains the converison methods common for a few classes converting data from the BE and to the BE */
export class BackendOrderConverter {

	public createOrderServiceUpdates(orderServices: OrderService[]): OrderServiceUpdate[] {
		if (!orderServices || orderServices.length === 0) {
			return [];
		}

		return orderServices.map((orderService: OrderService) => {
			const orderServiceUpdate = new OrderServiceUpdate();
			orderServiceUpdate.id = orderService.id;
			orderServiceUpdate.packageId = orderService.packageId;
			orderServiceUpdate.serviceId = orderService.serviceId;
			orderServiceUpdate.issueDate = orderService.issueDate;
			orderServiceUpdate.confirmationNumber = orderService.confirmationNumber;

			return orderServiceUpdate;
		});
	}

}
